import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(
    private toastr: ToastrService
  ) { }

  markAsTouched(obj) {
    // tslint:disable-next-line:forin
    for (const key in obj) {
      if (obj[key]['controls']) {
        this.markAsTouched(obj[key]['controls']);
      } else {
        obj[key].markAsTouched();
      }
    }
  }

  scrollToError(offset?) {
    const elementList = document.querySelectorAll('.ng-invalid:not(div):not(form):not(table):not(tr)');
    if (elementList && elementList.length > 0) {
      const element = elementList[0] as HTMLElement;
      const yOffset = offset ? offset : -70;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  }

  setErrors(errorsObj, form) {

    if (_.isString(errorsObj)) {
      this.toastr.error(errorsObj);
    } else {
      // tslint:disable-next-line:forin
      for (const key in errorsObj) {

        if (errorsObj[key].errors) {
          // console.log('key', key, 'errorsObj[key].errors', errorsObj[key].errors);
          const errors = {};
          // tslint:disable-next-line:forin
          for (const err in errorsObj[key].errors) {
            // console.log(err, errorsObj[key].errors[err]);
            errors[err] = errorsObj[key].errors[err];
          }
          if (form.controls[key] && errors) {
            // console.log('error', key, errorsObj[key].errors, errors);
            form.get(key).setErrors({backend: errors});
          }
        }

        // if (_.isObject(errorsObj[key].) && !_.isArray(errorsObj[key])) {
        //   const errors = {};
        //   // tslint:disable-next-line:forin
        //   for (const err in errorsObj[key]) {
        //     errors[err] = errorsObj[key][err];
        //   }
        //   form.get(key).setErrors({backend: errors});
        // } else {
        //   form.get(key).setErrors({backend: [errorsObj[key]]});
        // }
      }
      setTimeout(() => {
        this.scrollToError();
      });
    }
  }

  errorResponse(err, form) {

    console.log(err);

    if (err.status === 500) {
      this.toastr.error(
        `Jeżeli problem będzie się powtarzał - skontaktuj się z Administratorem.`,
        'Wystąpił problem z wysłaniem danych po API.'
      );
    } else {

      if (err.error && err.error.errors) {
        this.setErrors(err.error.errors.children, form);
      }
    }
  }

}
